module.exports = __webpack_public_path__ + "img/af.e26d2b17.svg";